import type { ApolloCache } from '@apollo/client';
import type { WatermarkTemplate } from '@frameio/graphql-client/generated';
import { WatermarkTemplateComplete } from './gql/fragments/generated/watermark_templates';

/**
 * Check if a watermark template contains any user input fields
 * @param template - The watermark template to check
 * @returns True if the template contains user input blocks, false otherwise.
 */
export const doesTemplateContainUserInputBlocks = (
  template: WatermarkTemplate | null | undefined
): boolean => {
  if (!template || !template.blocks) return false;

  return template.blocks.some(
    (block) =>
      block?.dataPoints &&
      block?.dataPoints.some(
        (dataPoint) => dataPoint?.__typename === 'WatermarkDataPointUserInput'
      )
  );
};

export const getTemplate = (cache: ApolloCache<any>, id: string) => {
  return cache.readFragment({
    id: cache.identify({ __typename: 'WatermarkTemplate', id }),
    fragment: WatermarkTemplateComplete,
    fragmentName: 'WatermarkTemplateComplete',
  });
};
